module.exports = __webpack_public_path__ + "media/images/product_lines/travel/h4-8ede540726330b504377a2a9824e6a51.svg";